import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Events } from '../../helpers/events';

// ionic
import { ModalController } from '@ionic/angular';

// rxjs
import { Subject } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";

// components
import { LiveVotingComponent } from "../live-voting/live-voting.component";

// providers
import { EventService } from "../../services/event.service";
import { FeedService } from "../../services/feed.service";
import { UserService } from "../../services/user.service";
import { OverlayService } from "../../services/overlay.service";
import { PlatformService } from "../../services/platform.service";

// models
import { Event } from "../../models/event";
import { Feed } from "../../models/feed";
import { User } from "../../models/user";

@Component({
    selector: 'app-invitations',
    templateUrl: './invitations.component.html',
    styleUrls: ['./invitations.component.scss'],
})
export class InvitationsComponent implements OnInit, OnDestroy {

    /**
     * unsubscribe subject
     *
     * @type {Subject<void>}
     */
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    /**
     * current event
     *
     * @type {User}
     */
    public user: User;

    /**
     * event
     *
     * @type {Event}
     */
    public event: Event;

    /**
     * constructor
     *
     * @param pushPageService
     * @param userProvider
     * @param appEvents
     */
    constructor(
        private router: Router,
        public eventService: EventService,
        public feedService: FeedService,
        public userService: UserService,
        public overlayService: OverlayService,
        public plt: PlatformService,
        public appEvents: Events,
        public modalController: ModalController
    ) {

    }

    ngOnInit() {
        this.userService.getCurrentUser().pipe(
            takeUntil(this.ngUnsubscribe),
            debounceTime(0)
        ).subscribe(
            (user: User) => {
                this.user = user;
            });

        this.eventService.getCurrentEvent().pipe(
            takeUntil(this.ngUnsubscribe),
            debounceTime(0)
        ).subscribe((event) => {
            this.event = event;
        });
    }

    /**
     * accept notification feed
     * @param Feed feed
     * @return void
     */
    public feedAccept(feed: Feed) {
        this.feedService.accept(feed).subscribe(
            success => {
                this.feedRequestSuccess(feed, success, true);
                // TODO
                //this.appEvents.broadcast('user:current:participant');
            },
            error => {
                this.feedRequestError(error);
            }
        );
    }

    /**
     * display notification Action
     * @param Feed feed
     * @return void
     */
    public feedDecline(feed: Feed) {
        this.feedService.decline(feed).subscribe(
            success => {
                this.feedRequestSuccess(feed, success);
                // TODO: display voting page
            },
            error => {
                this.feedRequestError(error);
            }
        );
    }

    /**
     * handle feed request success
     * @param Feed feed
     * @return void
     */
    public feedRequestSuccess(feed: Feed, success, redirect = false) {
        {
            this.close();
            this.overlayService.showSuccess(success.message);
            this.user.header_notifications = this.user.header_notifications.filter(item => {
                return item.id !== feed.id;
            });
            if (redirect) {
                // redirect to accepted event, so we will now show loading
                this.overlayService.showLoading();
            }
            this.appEvents.publish('user:current:participant', {
                redirectLink: this.plt.defaultLink + '/home/info/matching'
            });
        }
    }

    /**
     * handle feed request error
     * @return void
     */
    public feedRequestError(error) {
        {
            this.overlayService.showError(error.error.message);
        }
    }

    close() {
        this.modalController.dismiss({ action: 'close' });
    }

    /**
     * on destroy
     *
     * @return void
     */
    ngOnDestroy() {
        this.overlayService.closeModals();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
